import {
  ChecksumAddress,
  createRecord,
  getValueFromRecord,
  ProtocolKey,
  RecordWithDefaultValue,
} from "@silo/types";
import { assetConfig, AssetConfig } from "../utilities/asset-config-option";
import { ArbitrumTokenAddress, MainnetTokenAddress } from "@silo/addresses";

export const ASSET_CONFIGURATION: StaticAssetConfiguration = createRecord(
  {
    mainnetLegacy: createRecord<ChecksumAddress, AssetConfig>(
      {
        [MainnetTokenAddress.XAI]: assetConfig.create({
          disabledCollateral: {
            description:
              "SiloDAO recently made this change to improve the revenue model and decrease protocol risks.",
            link: "https://gov.silo.finance/t/scaling-xai-s-revenues-by-disabling-it-as-collateral-in-the-protocol/375",
          },
        }),
      },
      assetConfig.create({})
    ),
    mainnetLlama: createRecord<ChecksumAddress, AssetConfig>(
      {},
      assetConfig.create({})
    ),
    mainnetGrand: createRecord<ChecksumAddress, AssetConfig>(
      {},
      assetConfig.create({})
    ),
    arbitrum: createRecord<ChecksumAddress, AssetConfig>(
      {
        // WARNING: keep @silo/config value in sync
        [ArbitrumTokenAddress.USDC_e]: assetConfig.create({
          symbol: "USDC.e",
          name: "Bridged USDC",
        }),
      },
      assetConfig.create({})
    ),
    optimism: createRecord<ChecksumAddress, AssetConfig>(
      {},
      assetConfig.create({})
    ),
    base: createRecord<ChecksumAddress, AssetConfig>(
      {},
      assetConfig.create({})
    ),
    lrtbase: createRecord<ChecksumAddress, AssetConfig>(
      {},
      assetConfig.create({})
    ),
    local: createRecord<ChecksumAddress, AssetConfig>(
      {},
      assetConfig.create({})
    ),
    anvil: createRecord<ChecksumAddress, AssetConfig>(
      {},
      assetConfig.create({})
    ),
  },
  createRecord({}, assetConfig.create({}))
);

export type StaticAssetConfiguration = RecordWithDefaultValue<
  ProtocolKey,
  RecordWithDefaultValue<ChecksumAddress, AssetConfig>
>;

/**
 * @deprecated use function returned by `useAssetConfiguration` or `useSiloConfiguration` instead
 */
export const getConfigurationForAsset = (
  protocolInstance: ProtocolKey,
  assetAddress: ChecksumAddress
) => {
  const protocolInstanceAssetConfig = getValueFromRecord(
    protocolInstance,
    ASSET_CONFIGURATION
  );
  return getValueFromRecord(assetAddress, protocolInstanceAssetConfig);
};
